import util from '../util'

let controller = 'CustoContabil'
export default Object.assign({}, util.GetCrud(controller,
  ['get', 'getall', 'post', 'put', 'delete']
), {
  GetHistorico: function (id) {
    return util.Axios.Get(controller + '/GetHistorico', id)
  }
}
)
